import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { Component, Injector, OnInit } from '@angular/core';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { WarehousingSearchService } from '../../services/warehousing-search.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { CancelWarehousingRequest } from 'src/app/core/models/transport-operation/cancel-warehousing-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { BillService } from '../../../bill/service/bill.service';

@Component({
  selector: 'laas-warehousing-header-detail',
  templateUrl: './warehousing-header-detail.component.html',
  styleUrls: ['./warehousing-header-detail.component.scss']
})
export class WarehousingHeaderDetailComponent extends SessionBaseComponent implements OnInit {
  warehousingHeader: any;
  forwarderOptions: any[];
  billObjectTypeOptions: any[];
  billObjectOptions: any[];
  vendorCustomerOptions: any[];
  deliveryTypeOptions: any[];
  orgIdOptions: any[];
  billCorpOptions: any[];
  countryOptions: any[];
  cityOptions: any[];
  areaOptions: any[];
  expressTermOptions: LaasOption[];
  docTypeOptions: any[];
  shipTermOptions: any[];
  uomOptions: any[];
  brandOptions: any[];
  shippingRemarkOptions: any[];
  yesNoOptions: any[];
  addressCodeOptions: any[];
  shippingMethodOptions: any[];
  deliverySubTypeOptions: any[];
  whDocStatusOptions: any[] = [];
  isShowEditBtn: boolean;
  isShowEditRelatedBillBtn: boolean;
  isShowCancelBtn: boolean;
  isShowEditRelatedBill: boolean;

  urgentFlagOptions: any[];

  constructor(
    injector: Injector,
    private warehousingSearchService: WarehousingSearchService,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private billService: BillService
  ) {
    super(injector);
    this.warehousingHeader = {};
    this.forwarderOptions = [];
    this.billObjectTypeOptions = [];
    this.billObjectOptions = [];
    this.vendorCustomerOptions = [];
    this.deliveryTypeOptions = [];
    this.orgIdOptions = [];
    this.billCorpOptions = [];
    this.countryOptions = [];
    this.cityOptions = [];
    this.areaOptions = [];
    this.expressTermOptions = [];
    this.docTypeOptions = [];
    this.shipTermOptions = [];
    this.uomOptions = [];
    this.brandOptions = [];
    this.shippingRemarkOptions = [];
    this.yesNoOptions = [];
    this.addressCodeOptions = [];
    this.shippingMethodOptions = [];
    this.deliverySubTypeOptions = [];
    this.isShowEditBtn = false;
    this.isShowEditRelatedBillBtn = false;
    this.isShowCancelBtn = false;
    this.isShowEditRelatedBill = false;

    this.urgentFlagOptions = [];

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.yesNoOptions = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.urgentFlagOptions = [
      { label: '非急單', value: '5' },
      { label: '急單', value: '1' }
    ];

    const whNo = this.routeStateService.getCurrent().data.whNo;

    try {
      this.warehousingHeader = await this.warehousingSearchService.searchWarehousingByWhNo(whNo);
    } catch (err: any) {
      console.log('get warehousing header occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.warehousingHeader.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionsService.getVendorOptions(`${this.warehousingHeader.vendorCustomer}`).subscribe({
      next: result => {
        this.vendorCustomerOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliveryType').subscribe({
      next: result => {
        this.deliveryTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectOptions(this.warehousingHeader.facility, this.warehousingHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.warehousingHeader.facility, "").subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}(${x.legalEntityReferenceCode})`,
            value: x.legalEntityOUCode,
          };
        });

      }
    });

    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
      }
    });

    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.cityOptions = [...result].map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
          };
        });
      }
    });

    this.dropdownOptionsService.getAllAreaOptionForHK().subscribe({
      next: result => {
        this.areaOptions = [...result].map((x: any) => {
          return {
            label: x.rfqAreaName,
            value: x.rfqAreaCode,
            citySeqNo: x.citySeqNo,
          };
        });
      }
    });

    this.dropdownOptionsService.findFacilityOptionsByOptionType('ExpressTerm')
      .subscribe({
        next: (options: FacilityOptions[]) => {
          this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.shipTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getCarTypeOptions().subscribe({
      next: result => {
        this.uomOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBrandOptions(1).subscribe({
      next: result => {
        this.brandOptions = [...result].map((x: any) => {
          return {
            label: x.brandName,
            value: x.brandCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShippingRemark').subscribe({
      next: result => {
        this.shippingRemarkOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getPickupLocationOptionByDefault(this.laasSetting.facility).subscribe({
      next: result => {
        this.addressCodeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shippingMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliverySubType').subscribe({
      next: result => {
        this.deliverySubTypeOptions = [...result].map((x: any) => {
          return {
            label: x.codeDesc,
            value: x.codeKey,
          };
        });
      }

    });

    this.dropdownOptionsService.getWhDocStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.whDocStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });



    this.isShowEditBtn = true;
    if (this.warehousingHeader.whStatus !== 'C'
      && this.permissionCodes.includes(PermissionConstants.CancelWarehousing)
    ) {
      this.isShowCancelBtn = true;
    }
    this.isShowEditRelatedBillBtn = !(['C'].includes(this.warehousingHeader.whStatus)) &&
        this.permissionCodes.includes(PermissionConstants.EditWarehousingRelatedBilling);
  }

  goToEdit(event: any): void {
    this.routeStateService.navigateTo('/TransportOperation/WarehousingEdit', this.warehousingHeader);
  }

  cancelConfirm(event: any): void {
    this.confirmationService.confirm({
      message: '確定取消此筆入倉單?',
      header: '確定取消',
      accept: () => {
        this.cancelBooking(event);
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  cancelBooking(event: any): void {
    const whNo = this.warehousingHeader.whNo;
    this.loader.show();
    const deleteObj: CancelWarehousingRequest = {
      whNo,
      updateUser: this.userProfile.userName,
    };
    this.warehousingSearchService.cancelWarehousing(deleteObj)
      .pipe(finalize(() => this.loader.hide()))
      .subscribe({
        next: () => {
          this.toastService.success('取消成功');
          const resultObj = {
            bookingNoList: [whNo]
          };
          this.routeStateService.navigateTo('/TransportOperation/WarehousingSearch', resultObj);
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  showEditRelatedBillDialog(val: boolean): void {
    const whNo = this.routeStateService.getCurrent().data.whNo;
    if (!val) {
      this.isShowEditRelatedBill = val;
      this.ngOnInit();
      return;
    }
    this.billService.getBillingStatus(whNo).subscribe({
      next: result => {
        console.log(result);
        if (result) {
          for (const status of result.distinct()) {
            if (!['0', 'H'].includes(status)) {
              this.toastErrorMessage(this.translateService.instant('ReceiptFormHeaderDetails.Message.BillingStatusStageCannotBeModified'));
              val = false;
              break;
            }
          }
        }
        this.isShowEditRelatedBill = val;
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
        this.isShowEditRelatedBill = val;
      }
    });
  }
}
